import * as React from "react";
import { Box, Theme } from "@mui/material";
import { SxProps } from "@mui/system";
import { Span } from "#common/headings";
import { PropsWithChildren } from "react";

type TodoProps = {
    sx?: SxProps;
};
export const Todo = ({ children, sx }: PropsWithChildren<TodoProps>) => (
    <Box
        component="span"
        sx={sx === undefined ? sx : { backgroundColor: "crimson" }}
    >
        {children}
    </Box>
);
